

import { DateTimeAdapter } from 'ng-pick-datetime';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface SeqTemplateParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface SeqTemplate {
    id?: number;
    keyword?: string;
    textDesc: string;
    dateFormat:string;
    numberStart:number;
    length:number;
    padCharacter:string;
    tenantId?: string;
    increment: number;
    currentValue?:number;
    userId:string;
    entryDatatime?:Date;
    sortOrder:string;
    parameters?: SeqTemplateParameter[];
    links?: any;
    branchDataList?:any;
    type:string;
    generateSequenceBy:string;
    Separator:string;
}
export interface TypeOptions {
  value: number;
  title: string;
}

export abstract class SeqTemplateData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<SeqTemplate[]>;
  abstract getById(url: string): Observable<SeqTemplate>;
  abstract create(url: string,data: SeqTemplate): Observable<any>;
  abstract update(url: string,data: SeqTemplate): Observable<any>;
  abstract delete(url: string): Observable<any>;

  // Barcode Template page:-
  abstract listbarcode(url: string): Observable<any[]>;
  abstract createbarcode(url: string,data: any): Observable<any>;
}
